import { Col, TextLabel } from "../lib";
import { createStyles } from "../theme";

type Props = {
  value: string | number;
};

export function TopTabBadge({ value }: Props) {
  return (
    <Col.C style={$.container}>
      <TextLabel em color="onAccent">
        {value}
      </TextLabel>
    </Col.C>
  );
}

const $ = createStyles({
  container: {
    minWidth: 20,
    height: 20,
    borderRadius: 5,
    backgroundColor: "chatSecondary",
    mt: "2",
    mr: "2",
  },
});
